import { render } from "./LabelListView.vue?vue&type=template&id=70435312&scoped=true"
import script from "./LabelListView.vue?vue&type=script&lang=js"
export * from "./LabelListView.vue?vue&type=script&lang=js"

import "./LabelListView.vue?vue&type=style&index=0&id=70435312&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70435312"]])

export default __exports__